import React from "react";
import {QRCodeSVG} from 'qrcode.react';
import './styles.css';
const QRCodeGenerator = ({ text, variant }: { text: string; variant?: 'abstract' | 'poster' }) => {
  const variantClass = variant === 'abstract' ? 'qr-code-container--abstract' : variant === 'poster' ? 'qr-code-container--poster' : '';
  return (
    <div className={`qr-code-container ${variantClass}`.trim()}>
        <div className="qr-code-wrapper">
        <QRCodeSVG value={text} size={180} />

        </div>
        <span className="qr-code-span">Escanéa el QR y descargá el abstract o ePoster</span>
    </div>
  );
};

export default QRCodeGenerator;